import PropTypes from 'prop-types';
import { breakpoints } from '@styles/index';
import styled from 'styled-components';
import Benifits from './Benifits';
import Container, { StyledButton, Caption, Title, Description } from './styles';

const BackgroundColor = styled.div`
  background: #fcfcfc;
  padding-top: 120px;
  padding-bottom: 120px;
  @media (max-width: ${breakpoints.tablet}) {
    padding-top: 80px;
    padding-bottom: 80px;
  }
  @media (max-width: ${breakpoints.mobile}) {
    padding: 80px 16px 0;
  }
`;

const LeftSection = styled.img`
  grid-column: 1/17;
  object-fit: cover;
  cursor: pointer;
  user-drag: none;
  user-select: none;
  @media (max-width: ${breakpoints.tablet}) {
    margin-top: 40px;
  }
  @media (max-width: ${breakpoints.mobile}) {
    margin-top: 32px;
    height: 260px;
  }
`;

const RightSection = styled.section`
  grid-column: 18/25;
`;

const Header = styled.span`
  color: #2d81f7;
  margin-bottom: 0;
`;

const StyledContainer = styled(Container)`
  margin-bottom: 96px;
  @media (max-width: ${breakpoints.tablet}) {
    display: flex;
    flex-flow: column-reverse;
    margin-bottom: 40px;
    align-items: baseline;
  }
`;

const SubTitle = styled(Description)`
  @media (max-width: ${breakpoints.mobile}) {
    margin-bottom: 0;
  }
`;

function Practice({ scrollToForm, data, benifitsTitle }) {
  const {
    caption,
    title,
    subTitle,
    description,
    buttonText,
    resource,
    image
  } = data;
  return (
    <BackgroundColor>
      <StyledContainer>
        <LeftSection
          src={image}
          alt="practice"
          height="450"
          width="100%"
          loading="lazy"
        />
        <RightSection>
          <Caption>{caption}</Caption>
          <Title>
            <Header>{`${title} `}</Header>
            {subTitle}
          </Title>
          <SubTitle>{description}</SubTitle>
          <StyledButton onClick={scrollToForm} $hideSm>
            {buttonText}
          </StyledButton>
        </RightSection>
      </StyledContainer>
      <Benifits
        benifitsTitle={benifitsTitle}
        title={buttonText}
        benifits={resource}
        handleClick={() => {
          window.open('https://unacademy.app.link/2HAmrqP1ddb', '_blank');
        }}
      />
    </BackgroundColor>
  );
}

Practice.propTypes = {
  scrollToForm: PropTypes.func.isRequired,
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  benifitsTitle: PropTypes.string
};
Practice.defaultProps = {
  benifitsTitle: ''
};

export default Practice;
